<template>
    <div class="w-full my-2">
        <Link :href="'/song/' + song.id"
            class="w-full p-3 rounded-lg bg-nomad-800 hover:bg-nomad-700 text-nomad-200 hover:text-nomad-accent flex items-center justify-between transition-all duration-300 hover:shadow-md">

        <!-- Left side: thumbnail and text -->
        <div class="flex items-center gap-4 flex-1 min-w-0">
            <!-- Thumbnail -->
            <div class="flex-shrink-0">
                <img v-if="song.meta?.image" :src="song.meta?.image" :alt="`${song.name} cover`"
                    class="h-20 w-20 object-cover rounded-lg" />
            </div>

            <!-- Song info -->
            <div class="flex-1 min-w-0 ">
                <h2 class="text-lg font-semibold text-white line-clamp-1">
                    {{ song.name }}
                </h2>
                <h3 v-if="song.artist" class="text-md font-light  line-clamp-1 text-nomad-100">
                    {{ song.artist.name }}
                </h3>
            </div>
            <!-- Right side: duration -->
            <div class="flex-shrink-0 ml-4">
                <span v-if="song.formatted_duration" class="text-md font-light text-nomad-100">
                    {{ song.formatted_duration }}
                </span>
            </div>
        </div>


        </Link>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Link } from "@inertiajs/vue3";
export default {
    name: "CardSong",
    props: {
        song: Object,
    },
    components: {
        Link,
    },
    methods: {
        ...mapActions("favorites", [""]),
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
